/**
 * Reply Button Component
 * Button to initiate reply to a message
 */

import type { Message } from '@/types/api.types';

interface ReplyButtonProps {
  message: Message;
  onReply: (message: Message) => void;
}

const ReplyButton = ({ message, onReply }: ReplyButtonProps) => {
  return (
    <button
      onClick={() => onReply(message)}
      className="p-2 text-gray-500 hover:text-blue-600 rounded-lg transition-colors"
      title="Отговори"
    >
      <svg
        className="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"
        />
      </svg>
    </button>
  );
};

export default ReplyButton;
